import { useGetAppByIdQuery } from "@store/apis/magicoApi";
import { setAppConfig } from "@store/slices/appConfig";
import { applyFonts, applyThemeColors } from "@utilities/appUtils";
import { appConfig } from "app.config";
import { useEffect } from "react";

import { useRemoteTranslations } from "./useRemoteTranslations";
import { useAppDispatch } from "./useRedux";


export const useAppConfigFetcher = (appId?: string) => {
  const numericAppId = appId ? Number.parseInt(appId, 10) : 0;
  const { data, isLoading, error } = useGetAppByIdQuery(numericAppId, {
    skip: !appId,
  });
  const dispatch = useAppDispatch();
  const { loadTranslations } = useRemoteTranslations();

  useEffect(() => {
    if (!data) return;

    dispatch(setAppConfig(data));
    if (data.colors) {
      applyThemeColors(data.colors);
    }

    if (data.configs) {
      applyFonts(data.configs);
    }

    loadTranslations(numericAppId);
  }, [data, dispatch, loadTranslations, numericAppId]);

  return { isLoading, error, appConfig };
};
